// extracted by mini-css-extract-plugin
module.exports = {"commentFormPlaceholder":"_3eB7N","commentFormWrapper":"_2KjjO","commentForm":"_19wZy"};